(function () {
  'use strict';

  var SUPPORT_COPY_HANDLE = 'korean-polyester-crepe-fabric-copy';
  var TURKISH_SUPPORT_HANDLE = 'printed-rayon-viscose-jacquard-170-gsm';

  function normalizedPath(handle) {
    return '/products/' + String(handle || '').replace(/^\/+|\/+$/g, '');
  }

  function cardForHandle(handle) {
    var path = normalizedPath(handle);
    return Array.prototype.slice.call(document.querySelectorAll('grid-item[data-url]')).filter(function (card) {
      var actual = String(card.dataset.url || '').split('?')[0];
      return actual === path || actual.slice(-path.length) === path;
    });
  }

  function hideExtensionCards(config) {
    var handles = (config.copyHandles || []).slice();
    if (handles.indexOf(SUPPORT_COPY_HANDLE) === -1) handles.push(SUPPORT_COPY_HANDLE);
    if (handles.indexOf(TURKISH_SUPPORT_HANDLE) === -1) handles.push(TURKISH_SUPPORT_HANDLE);

    handles.forEach(function (handle) {
      cardForHandle(handle).forEach(function (card) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function withVariant(url, variantId) {
    if (!url || !variantId) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('variant', String(variantId));
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      var base = String(url).split('?')[0];
      return base + '?variant=' + encodeURIComponent(String(variantId));
    }
  }

  function updateLinks(card, variantId) {
    card.querySelectorAll('a[data-product-link], a.product-link, a.hiba-product-card__link').forEach(function (link) {
      var next = withVariant(link.getAttribute('href') || '', variantId);
      if (next) {
        link.setAttribute('href', next);
        link.dataset.productLink = next;
      }
    });
  }

  function updateLabel(card, label) {
    if (!label) return;
    var output = card.querySelector('.hiba-product-card__variant-label');
    if (!output) return;
    output.textContent = String(label).trim();
  }

  function updateImage(card, config) {
    if (!config.imageSrc) return;

    card.classList.remove('double__image');
    var imageWrapper = card.querySelector('.product-item__image');
    if (imageWrapper) imageWrapper.classList.remove('double__image');

    card.querySelectorAll('.product-item__bg__under').forEach(function (node) {
      node.style.setProperty('display', 'none', 'important');
    });

    card.querySelectorAll('[data-product-image-default] img').forEach(function (img) {
      img.src = config.imageSrc;
      if (config.imageSrcset) {
        img.srcset = config.imageSrcset;
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
      if (config.imageAlt) img.alt = config.imageAlt;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  function canonicalizeMainCard(config) {
    cardForHandle(config.mainHandle).forEach(function (card) {
      updateLinks(card, config.variantId);
      updateLabel(card, config.label || config.name);
      updateImage(card, config);
      card.dataset.hibaCanonicalVariant = String(config.variantId || '');
    });
  }

  function apply() {
    var config = window.__hibaCanonicalCollectionCard;
    if (!config) return;
    hideExtensionCards(config);
    canonicalizeMainCard(config);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', schedule);

  if (document.body) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }
})();
